import { FC } from 'react';
import {
  Control,
  useFieldArray,
  UseFormGetValues,
} from 'react-hook-form-latest';
import { Box } from '@mui/material';
import { Typography } from 'melp-design/components';
import { Values } from '../../survey-content.types';

export const QuestionsList: FC<{
  control: Control<Values>;
  questionIndex: number;
  getValues: UseFormGetValues<Values>;
}> = ({ control, questionIndex, getValues }) => {
  const { fields } = useFieldArray({
    name: `questions.${questionIndex}.translations`,
    control,
  });

  const selectedLanguage = getValues('ui.selectedLanguage');

  return (
    <>
      {fields.map((field, i) => (
        <Box
          key={field.id}
          sx={{
            display: selectedLanguage === field.language ? 'block' : 'none',
          }}
        >
          <Typography maxLines={1}>
            {`${questionIndex + 1}. ${
              getValues(`questions.${questionIndex}.translations.${i}.text`) ||
              '-'
            }`}
          </Typography>
        </Box>
      ))}
    </>
  );
};
